import { Controller } from "@hotwired/stimulus"
import ga from "../utils/ga"

export default class extends Controller {
  connect() {
    ga("send", { hitType: "pageview", title: document.title })

    // When campaign params are set (e.g. utm_source=...), a session is created,
    // however at the next pageview sent without a fullpage refresh (like a turbolink
    // app) the content of http header is read and a new session is started. Nulling the
    // referrer value in the tracker at the end of the page on every pageview resolves this.
    ga("set", { referrer: null })
  }
}
